export default "__VITE_ASSET__DRfoe0AZ__"